import * as util from '#packages/util';

const { deepFreeze } = util;

const stateFreezer =
  (reducer: AnyFixMe) => (state: AnyFixMe, action: AnyFixMe) =>
    deepFreeze(reducer(state, action));

export default stateFreezer;
